import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const listRowAttribute = "data-dotlegal-list-row";
export const listFooterAttribute = "data-dotlegal-list-footer";
export const revealOnRowHoverAttribute = "data-reveal-on-row-hover";

export const useDotLegalListStyles = () => {
    const theme = useTheme();
    const divider = `1px solid ${theme.palette.grey[200]}`;

    return createSxStyles({
        list: {
            border: divider,
            borderRadius: "10px",
            overflow: "hidden",
            // Rows may sit in a wrapper of their own (a drag-and-drop container), so the footer cannot tell from its
            // siblings whether a row is above it.
            [`&:has([${listRowAttribute}]) > [${listFooterAttribute}]`]: {
                borderTop: divider,
            },
        },
        row: {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(1),
            paddingY: theme.spacing(0.75),
            paddingLeft: theme.spacing(1.5),
            paddingRight: theme.spacing(1),
            backgroundColor: theme.palette.background.paper,
            [`& + [${listRowAttribute}]`]: {
                borderTop: divider,
            },
            // Row actions only appear on the row under the pointer, or the row holding focus, so the list reads as plain content.
            [`&:hover [${revealOnRowHoverAttribute}], &:focus-within [${revealOnRowHoverAttribute}]`]: {
                visibility: "visible",
            },
        },
        rowContent: {
            flex: 1,
            minWidth: 0,
        },
        removeButton: {
            visibility: "hidden",
            "&:hover svg": {
                color: theme.palette.grey[700],
            },
        },
        removeIcon: {
            fontSize: 18,
            color: theme.palette.grey[500],
        },
        addButton: {
            paddingY: theme.spacing(0.25),
            "& .MuiButtonBase-root, & .MuiButtonBase-root:hover": {
                paddingLeft: "12px",
            },
        },
        addContent: {
            paddingY: theme.spacing(0.25),
            paddingLeft: theme.spacing(1.5),
            paddingRight: theme.spacing(1),
        },
    });
};
